import React, { useEffect, useState } from 'react';
import { API } from 'aws-amplify';
import Loadingmini from '../components/loadingmini';
import { Flex, Divider, View, Text, Heading, Button, TextField } from '@aws-amplify/ui-react';

export default function Usernotes({ userJwt, userId, fleetCode }) {

  const [is_loading, updateIsLoading] = useState(false);
  const [notes, updateNotes] = useState([]);
  const [newNote, updateNewNote] = useState("");
  const [editingNoteId, updateEditingNoteId] = useState(null);
  const [editingText, updateEditingText] = useState("");

  function sortNewestFirst(arr) {
    return [...arr].sort((a, b) => {
      const aTime = new Date(a.created || a.created_datetime || 0).getTime();
      const bTime = new Date(b.created || b.created_datetime || 0).getTime();
      return bTime - aTime;
    });
  }

  async function fetchNotes() {
    updateIsLoading(true);

    const myInit = {
      queryStringParameters: {
        back_end: process.env.REACT_APP_BACKEND,
        jwt: userJwt,
        api_endpoint: "api3:portal:driver_desk",
        section: "notes",
        request_type: "GET",
        fleet_code: fleetCode,
        driver_id: userId
      }
    };
    try {
      const res = await API.get('adminWebTools', '/ago', myInit);
      if (res?.resp) {
        //console.log(JSON.stringify(res));
        updateNotes(sortNewestFirst(res.resp));
      } else {
        console.log('no notes array received')
        updateNotes([]);
      }
    } catch (e) {
      console.log(e);
      updateNotes([]);
    }

    updateIsLoading(false);
  }

  useEffect(() => {
    if (userJwt && fleetCode && userId) {
      fetchNotes();
    }
  }, [userJwt, fleetCode, userId]);

  async function createNote() {
    if (!newNote.trim()) return;

    updateIsLoading(true);

    //console.log('new note')
    //console.log('fleet_code: '+fleetCode);
    //console.log('driver_id: '+userId);
    //console.log('note: '+newNote);

    const myInit = {
      queryStringParameters: {
        back_end: process.env.REACT_APP_BACKEND,
        jwt: userJwt,
        api_endpoint: "api3:portal:driver_desk",
        section: "notes",
        fleet_code: fleetCode,
        request_type: "POST",
        action: "new_note",
        fleet_code: fleetCode,
        driver_id: userId,
        note: newNote
      }
    };


    try {
      const res = await API.post('adminWebTools', '/ago', myInit);

      if (res?.resp.note_id) {
      /*
        const newEntry = {
          note_id: res.note_id,
          note: newNote,
          author: res.author,
          created: res.created || new Date().toISOString()
        };

        updateNotes(sortNewestFirst([newEntry, ...notes]));
        */
       fetchNotes();
      }

      updateNewNote("");
    } catch (e) {
      console.log(e);
    }

    updateIsLoading(false);
  }

  async function deleteNote(note_id) {
    const confirmDelete = window.confirm("Delete this note?");
    if (!confirmDelete) return;

    updateIsLoading(true);

    const myInit = {
      queryStringParameters: {
        back_end: process.env.REACT_APP_BACKEND,
        jwt: userJwt,
        api_endpoint: "api3:portal:driver_desk",
        section: "notes",
        request_type: "POST",
        action: "delete_note",
        fleet_code: fleetCode,
        driver_id: userId,
        note_id
      }
    };

    try {
      await API.post('adminWebTools', '/ago', myInit);
      updateNotes(notes.filter(n => n.note_id !== note_id));
    } catch (e) {
      console.log(e);
    }

    updateIsLoading(false);
  }

  async function saveEdit(note_id) {
    updateIsLoading(true);

    const myInit = {
      queryStringParameters: {
        back_end: process.env.REACT_APP_BACKEND,
        jwt: userJwt,
        api_endpoint: "api3:portal:driver_desk",
        section: "notes",
        request_type: "POST",
        action: "edit_note",
        fleet_code: fleetCode,
        driver_id: userId,
        note_id,
        note: editingText
      }
    };

    try {
      await API.post('adminWebTools', '/ago', myInit);

      updateNotes(sortNewestFirst(
        notes.map(n =>
          n.note_id === note_id
            ? { ...n, note: editingText, edited: new Date().toISOString() }
            : n
        )
      ));

      updateEditingNoteId(null);
      updateEditingText("");
    } catch (e) {
      console.log(e);
    }

    updateIsLoading(false);
  }

  function formatDate(ts) {
    if (!ts) return "";
    try {
      return new Date(ts).toLocaleString();
    } catch {
      return ts;
    }
  }

  return (
    is_loading ? <Loadingmini /> :
    <Flex direction="column">
      <View style={{ padding: "1rem" }}>
        <Divider />
        <Heading level={4}>User Notes</Heading>

        <Flex direction="column" gap="0.5rem">
          <TextField
            placeholder="Add note..."
            value={newNote}
            onChange={(e) => updateNewNote(e.target.value)}
          />
          <Button onClick={createNote}>
            Add Note
          </Button>
        </Flex>

        <Divider />

        {
          notes.length === 0 ?
            <Text>No notes</Text>
          :
          <Flex direction="column" gap="0.75rem">
            {
              notes.map((note) => (
                <View
                  key={note.note_id}
                  style={{
                    border: "1px solid #ddd",
                    padding: "0.75rem",
                    borderRadius: "6px"
                  }}
                >
                  {
                    editingNoteId === note.note_id ?
                      <Flex direction="column" gap="0.5rem">
                        <TextField
                          value={editingText}
                          onChange={(e) => updateEditingText(e.target.value)}
                        />

                        <Flex gap="0.5rem">
                          <Button onClick={() => saveEdit(note.note_id)}>
                            Save
                          </Button>
                          <Button
                            variation="link"
                            onClick={() => updateEditingNoteId(null)}
                          >
                            Cancel
                          </Button>
                        </Flex>
                      </Flex>
                    :
                      <Flex direction="column" gap="0.25rem">

                        <Text>{note.note}</Text>

                        <Flex
                          justifyContent="space-between"
                          alignItems="center"
                          style={{ fontSize: "0.8rem", color: "#666" }}
                        >
                          <Text>
                            {note.author || "Unknown"} • {formatDate(note.created || note.created_datetime) + " (server time)"}
                            {note.edited ? " (edited)" : ""}
                          </Text>

                          <Flex gap="0.5rem">
                            <Button
                              size="small"
                              variation="link"
                              onClick={() => {
                                updateEditingNoteId(note.note_id);
                                updateEditingText(note.note);
                              }}
                            >
                              Edit
                            </Button>

                            <Button
                              size="small"
                              variation="link"
                              onClick={() => deleteNote(note.note_id)}
                            >
                              Delete
                            </Button>
                          </Flex>
                        </Flex>

                      </Flex>
                  }

                </View>
              ))
            }
          </Flex>
        }

      </View>
    </Flex>
  );
}